<template>
    <div class="tile-content">
    <plan-details-table
        :plan="plan"
        :plans-custom-fields="plansCustomFields"
        :product="product">
        <v-popper class="grid-item no-flex" position="bottomEnd" ref="csvUpload" :offset="8" slot="actions">
            <div slot="trigger">
                <v-icon-button class="no-padding" size="small" type="basic" v-popper-trigger>
                    <v-icon icon="actions"/>
                </v-icon-button>
            </div>
            <div class="popover" slot="content">
                <div class="popover-control">
                    <div class="popover-content popover-menu">
                        <a class="popover-menu-item" @click="toggleUpdateModal()">Edit Pricing Plan</a>
                        <a class="popover-menu-item popover-menu-item-negative" @click="toggleDeleteModal()">Delete
                            Pricing Plan</a>
                    </div>
                </div>
            </div>
        </v-popper>
    </plan-details-table>
    <!-- Update plan modal -->
    <v-modal v-if="showPlanUpdateModal" title="Edit Pricing Plan Details" @close="toggleUpdateModal()"
             size="small">
        <div slot="content">
            <v-error-messages v-if="$v.planUpdate.$error" class="stack-l">
                <li class="list-item" v-if="!$v.planUpdate.name.required">Plan name is required</li>
            </v-error-messages>
            <p class="stack-m">Edit your pricing plan information.</p>
            <div class="grid-content">
                <div class="grid-item grid-item-full">
                    <r-input label="Plan Name" v-model="planUpdate.name" :validate="$v.planUpdate.name"/>
                </div>
                <div class="grid-item grid-item-full">
                    <r-checkbox
                        label="Is Active"
                        :value="true"
                        v-model="planUpdate.isActive"
                    />
                </div>
                <v-custom-fields-manager
                    fluid
                    resource-type="plans"
                    :preload-custom-fields="plansCustomFields"
                    v-model="planUpdate.customFields"/>
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="updatePlan">Update Plan</r-button>
        </template>
    </v-modal>
    <!-- Delete Plan Modal -->
    <v-modal v-if="showPlanDeleteModal" title="Delete Pricing Plan" @close="toggleDeleteModal()" size="small">
        <div slot="content">
            <p v-if="plan.hasSubscriptions">
                This plan cannot be deleted because it contains subscriptions. Only Plans without subscriptions can
                be deleted.
            </p>
            <p v-else>Are you sure you want to delete this pricing plan?</p>
        </div>
        <template slot="actions" v-if="!plan.hasSubscriptions">
            <r-button type="danger" @click="deletePlan">Delete Plan</r-button>
        </template>
    </v-modal>
    </div>
</template>

<script>
    import PlanModel from '@/common/models/plan-model';
    import ProductModel from '@/common/models/product-model';
    import vModal from '@/components/modal/v-modal';
    import {
        vCheckbox,
        vIconButton,
        vIcon,
        vErrorMessages,
    } from '@/components/form';
    import vPopper from '@/components/v-popper';
    import PricingRenderer from '@/modules/plans/pricing-renderer';
    import {required} from 'vuelidate/lib/validators';
    import vCustomFieldsManager from '@/components/custom-fields/v-custom-fields-manager';
    import PlanDetailsTable from '@/modules/plans/components/plan-details-table';

    export default {
        name: 'pricing-plan-list',
        components: {
            vModal,
            vCheckbox,
            vIconButton,
            vIcon,
            vErrorMessages,
            vPopper,
            vCustomFieldsManager,
            'plan-details-table': PlanDetailsTable,
        },
        props: {
            plan: {
                type: PlanModel,
            },
            product: {
                type: ProductModel,
            },
            plansCustomFields: {
                type: Array,
            },
        },
        data() {
            return {
                showPlanUpdateModal: false,
                showPlanDeleteModal: false,
                planUpdate: new PlanModel({...this.plan}),
            };
        },
        validations: {
            planUpdate: {
                name: {required},
            },
        },
        computed: {
            pricing() {
                return PricingRenderer.render(
                    this.plan.currency,
                    this.plan.pricing,
                    this.plan.recurringInterval,
                    this.product.unitLabel,
                );
            },
        },
        methods: {
            toggleUpdateModal() {
                this.showPlanUpdateModal = !this.showPlanUpdateModal;
            },
            toggleDeleteModal() {
                this.showPlanDeleteModal = !this.showPlanDeleteModal;
            },
            updatePlan() {
                this.$v.$touch();
                if (!this.$v.planUpdate.$error) {
                    this.$emit('input', this.planUpdate);
                    this.toggleUpdateModal();
                }
            },
            deletePlan() {
                this.$emit('delete', this.planUpdate);
                this.toggleDeleteModal();
            },
        },
    };
</script>
